import { useMemo } from 'react'
import { shuffle } from 'lodash'
import { useStaticData } from '@mc/static-data-react'
import { EpisodeStaticData } from '../../[episodeSlug].page'

export const useRelatedContent = () => {
  const { relatedCourses, relatedChapters } = useStaticData<EpisodeStaticData>()
  const relatedContent = useMemo(
    () => shuffle([...relatedCourses, ...relatedChapters]),
    [relatedChapters, relatedCourses],
  )

  return relatedContent
}
